import { useEffect, useState } from "react";
import CreateGroupComponent from "../../../Comp/Group/CreateGroup/CreateGroup";
// import axios from "axios";
import { useLocation } from "react-router-dom";
import axios from "../../../api/axios/axios";
import CreateAnnoucement from "../../../Comp/Group/CreateAnnoucement/CreateAnnoucementComponent";
import CreateAnnoucementComponent from "../../../Comp/Group/CreateAnnoucement/CreateAnnoucementComponent";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
const CreateAnnouncement = () => {
  const [categories, setCategories] = useState([]);
  const [rowData, setRowData] = useState({});
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    const fetchCategories = async () => {
      const controller = new AbortController();
      const response = await axiosPrivate.get("/api/deals/showappdealsgroup", {
        signal: controller.signal,
      });
      console.log("Groups Response", response);
      const categories = response.data.data
        .filter((cat) => {
          return (
            (cat.active === true || cat.active === "true") &&
            (cat?.announcement === true || cat?.announcement === "true")
          );
        })
        .map((category) => ({
          value: category._id,
          label: category.name,
        }));

        console.log(categories,"Categories Filter")

      setCategories(categories);

      // console.log(response, "response");
    };
    fetchCategories();
  }, []);

  const location = useLocation();
  const fullRowData = location?.state?.fullRowData;
  useState(() => {
    setRowData(fullRowData);
  }, [fullRowData]);
  // console.log(rowData, "rowData");
  // console.log(categories, "categories");
  // console.log(stores, "stores");

  return (
    <CreateAnnoucementComponent categories={categories} rowData={rowData} />
  );
};
export default CreateAnnouncement;
